// Interests — 24 chips, emoji-led to match Hi-Fi style.
// Order preserved as a rough popularity heuristic (PRD §05 screen 03).
export const SKAZKI_INTERESTS = [
    {emoji: '🐴', label: 'лошадки'},
    {emoji: '🌙', label: 'космос'},
    {emoji: '🦄', label: 'единороги'},
    {emoji: '🌸', label: 'цветы'},
    {emoji: '🐉', label: 'драконы'},
    {emoji: '🐱', label: 'котики'},
    {emoji: '🏰', label: 'замки'},
    {emoji: '🐻', label: 'мишки'},
    {emoji: '🚂', label: 'паровозы'},
    {emoji: '🎈', label: 'шары'},
    {emoji: '🦕', label: 'динозавры'},
    {emoji: '🤖', label: 'роботы'},
    {emoji: '⚽', label: 'футбол'},
    {emoji: '🌊', label: 'море'},
    {emoji: '🦊', label: 'лисы'},
    {emoji: '🏴\u200d☠️', label: 'пираты'},
    {emoji: '✨', label: 'волшебство'},
    {emoji: '🌲', label: 'лес'},
    {emoji: '🎪', label: 'цирк'},
    {emoji: '🦸', label: 'супергерои'},
    {emoji: '🎨', label: 'рисование'},
    {emoji: '⚡', label: 'молнии'},
    {emoji: '🍪', label: 'печенье'},
    {emoji: '🎵', label: 'музыка'},
];

export const SKAZKI_GENRES = [
    {
        id: 'adventure',
        emoji: '🗺️',
        illustration: '/skazki/adventure.jpg',
        name: 'Приключение',
        caption: 'Путешествия, поиски, команда',
        popularAges: [5, 6, 7, 8, 9]
    },
    {
        id: 'magic',
        emoji: '🏰',
        illustration: '/skazki/Magic.jpg',
        name: 'Волшебство',
        caption: 'Магия, загадочные существа',
        popularAges: [4, 5, 6, 7]
    },
    {
        id: 'slice_of_life',
        emoji: '🏡',
        illustration: '/skazki/kind-everyday-tale.jpg',
        name: 'Добрая быль',
        caption: 'Случай из жизни, без магии',
        popularAges: [6, 7, 8, 9, 10, 11, 12]
    },
    {
        id: 'science',
        emoji: '🔬',
        illustration: '/skazki/scientific.jpg',
        name: 'Научная',
        caption: 'Как устроен мир, немного фактов',
        popularAges: [8, 9, 10, 11, 12]
    },
    {
        id: 'funny',
        emoji: '🎭',
        illustration: '/skazki/funny.jpg',
        name: 'Смешная',
        caption: 'Нелепые ситуации, ирония',
        popularAges: [4, 5, 6, 7, 8]
    },
    {
        id: 'bedtime',
        emoji: '🌙',
        illustration: '/skazki/bedtime.jpg',
        name: 'Перед сном',
        caption: 'Медленная, убаюкивающая',
        popularAges: [3, 4, 5]
    },
];

export const SKAZKI_MORALS = [
    'Делиться',
    'Не бояться нового',
    'Быть добрым к животным',
    'Убирать за собой',
    'Не врать',
    'Помогать близким',
    'Быть терпеливым',
    'Дружить',
];


export const SKAZKI_TEMPOS = [
    {id: 'slow', name: 'Медленнее'},
    {id: 'normal', name: 'Обычный'},
    {id: 'fast', name: 'Быстрее'},
];

export function durationHintForAge(age) {
    if (age <= 4) return '3 минуты';
    if (age <= 6) return '5 минут';
    if (age <= 9) return '7 минут';
    return '10 минут';
}

export function ageDescription(age) {
    if (age <= 4) return 'Простые слова, повторы, знакомые образы';
    if (age <= 6) return 'Короткие предложения, знакомые герои';
    if (age <= 9) return 'Поворот сюжета, новые слова';
    return 'Сложнее сюжет, диалоги и детали';
}

export function ageWord(age) {
    const last = age % 10;
    if (age === 1) return 'один год';
    if (last === 1 && age !== 11) return `${age} год`;
    if ([2, 3, 4].includes(last) && ![12, 13, 14].includes(age)) return `${age} года`;
    return `${age} лет`;
}

export const SKAZKI_GENERATION_STATUSES = [
    'Собираем сюжет…',
    'Рисуем обложку…',
    'Подбираем голос…',
    'Записываем аудио…',
    'Сохраняем на серверах…',
    'Почти готово…',
];

export function recommendedGenreIdForAge(age) {
    if (age <= 4) return 'bedtime';
    if (age <= 6) return 'magic';
    if (age <= 9) return 'adventure';
    return 'slice_of_life';
}

export function formatDuration(totalSec) {
    if (!totalSec && totalSec !== 0) return '—';
    const m = Math.floor(totalSec / 60);
    const s = Math.floor(totalSec % 60);
    return `${m}:${s.toString().padStart(2, '0')}`;
}

export function normalizeChildName(raw) {
    if (!raw) return '';
    const cleaned = raw.trim().replace(/\s+/g, ' ').slice(0, 24);
    return cleaned.charAt(0).toLocaleUpperCase('ru-RU') + cleaned.slice(1);
}

export const SKAZKI_QUICK_NAMES = ['Маша', 'Миша', 'Соня', 'Лёва', 'малыш', 'солнышко'];
